import { BookabilityCode, BookabilityStatus } from "@clipboard-health/contract-worker-app-bff";

import { type OpenShift } from "./types";

export function isBasketSizeLimitedShift(shift: OpenShift) {
  return (
    shift.attributes.bookability?.status === BookabilityStatus.UNBOOKABLE &&
    shift.attributes.bookability?.reasons.some(
      (reason) =>
        reason.code === BookabilityCode.BASKET_SIZE_LIMIT_REACHED ||
        reason.code === BookabilityCode.LEAD_TIME_THRESHOLD_EXCEEDED
    )
  );
}

export function extractBasketSizeLimitRestriction(
  bookability: OpenShift["attributes"]["bookability"]
): number | undefined {
  if (bookability?.status !== BookabilityStatus.UNBOOKABLE) {
    return undefined;
  }

  return bookability?.reasons.find(
    (reason) => reason.code === BookabilityCode.BASKET_SIZE_LIMIT_REACHED
  )?.metadata?.basketSizeLimit;
}

export function extractLeadTimeThresholdRestriction(
  bookability: OpenShift["attributes"]["bookability"]
): number | undefined {
  if (bookability?.status !== BookabilityStatus.UNBOOKABLE) {
    return undefined;
  }

  return bookability?.reasons.find(
    (reason) => reason.code === BookabilityCode.LEAD_TIME_THRESHOLD_EXCEEDED
  )?.metadata?.leadTimeThresholdInHrs;
}
